export default [
    {
        path: '/faqs',
        name: 'faqs',
        component: () => import ('./pages/Index')
    },
]